<template>
  <div class="submit-success">
    <!-- header -->
    <div class="submit-header">
      <van-icon name="checked" />
      <div class="submit-success-text">
        山东省农民工工资支付监管平台已收到您反映的问题线索，并推送至属地人社部门，我们将督促属地依法依规及时处理，请保持电话畅通。
      </div>
    </div>
    <!-- tip -->
    <div class="submit-tip">
      各市、县（市、区）人社部门联系方式如下，请注意保存：
    </div>
    <!-- 电话列表 -->
    <div class="submit-city-list">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          v-for="(city, index) in cityList"
          :title="city?.areaName"
          :name="index"
          :key="city?.areaCode"
        >
          <div class="submit-phone-list">
            <div
              class="submit-phone-item"
              v-for="item in city?.children ?? []"
              :key="item?.areaCode"
            >
              <div class="submit-phone-item-city">{{ item?.areaName }}</div>
              <div>
                <div
                  class="submit-phone-item-number"
                  v-for="phone in item?.complaintsHotline ?? []"
                  :key="phone">
                  <a :href="`tel:${phone}`">{{ phone }}</a>
                </div>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: null,
      cityList: []
    };
  },
  methods: {
    getCityList() {
      this.$http.findRegionalContactsList({}).then(res => {
        this.cityList = res.map(item => {
          return {
            ...item,
            children: item?.children.map(childrenitem => {
              return {
                ...childrenitem,
                complaintsHotline: childrenitem?.complaintsHotline?.split("/")
              };
            })
          };
        });
      });
    }
  },
  mounted() {
    this.getCityList();
  }
};
</script>

<style lang="less" scoped>
.submit-success {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: rgb(238, 241, 248);
  .submit-header {
    text-align: center;
    background-color: #fff;
    margin: 12px 16px;
    padding: 16px;
    i {
      font-size: 30px;
      color: rgb(20, 172, 68);
    }
    .submit-success-text {
      font-size: 13px;
      margin-top: 16px;
      line-height: 22px;
      color: #777;
    }
  }
  .submit-tip {
    text-align: left;
    padding: 10px 16px;
    background-color: #fff;
    color: rgb(53, 117, 252);
    font-size: 12px;
    margin-bottom: 12px;
  }
  .submit-city-list {
    .submit-phone-list {
      .submit-phone-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .submit-phone-item-city {
        }
        .submit-phone-item-number {
          padding: 2px 0;
        }
      }
    }
  }
}
</style>
<style lang="less">
.submit-city-list {
  .van-collapse-item {
    .van-cell__title {
      position: relative;
      padding-left: 10px;
      &::after {
        position: absolute;
        left: 0;
        top: 6px;
        content: "";
        width: 3px;
        height: 13px;
        background-color: rgb(53, 117, 252);
        border-radius: 1px;
      }
    }
    .van-collapse-item__wrapper {
      .van-collapse-item__content {
        padding: 0 16px;
        .submit-phone-list {
          .submit-phone-item {
            padding: 8px 0;
            border-bottom: 1px solid #ebedf0;
            font-size: 13px;
            &:last-of-type {
              border-bottom-width: 0;
            }
          }
        }
      }
    }
  }
}
</style>
